import { getUrlLink } from '@/services/user'
import { useEffect } from 'react'
import './index.less'

const Download = () => {
  useEffect(() => {
    openLink()
  }, [])
  const openLink = async () => {
    const res = (await getUrlLink()) as unknown as string
    console.log(res)
    window.location.href = res
  }
  return (
    <div className="page download">
      <img className="mini-code" src={require('./miniprogram.jpg')} alt="" />
      <div className="tip">微信扫码/长按识别进入小程序</div>
    </div>
  )
}

export default Download
